import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BaseListGroup',
  props: {
    flush: {
      type: Boolean,
      default: true
    },
    direction: {
      default: 'column'
    },
    dividers: {
      type: Boolean
    }
  },
  setup(__props) {
    return {
      __sfc: true
    };
  }
});